<div class="chat-page" [class.chat-page--open]="!!activeConversation" [class.chat-page--aside]="asideOpen" [class.chat-page--widget]="widget">

  <!-- Autenticado mas sem conta de chat nesta entidade (contrato 6.1): um estado, não uma espera. -->
  <ng-container *ngIf="noChatIdentity; else chatUi">
    <section class="card chat-card chat-card--single">
      <chat-empty-state icon="info" [title]="strings.noChatIdentityTitle" [text]="strings.noChatIdentityText"></chat-empty-state>
    </section>
  </ng-container>

  <ng-template #chatUi>
    <!-- coluna 1: lista -->
    <section class="card chat-card chat-card--list" [attr.aria-label]="strings.listTitle">
      <!-- Contrato 6.3, v8: convites que esperam pela minha resposta -->
      <chat-invites *ngIf="invites.length > 0" [invites]="invites" [busy]="inviteBusy" [profileBase]="profileImageBase"
        [strings]="strings" (accept)="acceptInvite($event)" (decline)="declineInvite($event)"></chat-invites>
      <chat-conversation-list [conversations]="users" [queue]="queueVisible" [unreadTotals]="unreadTotals" [activeKey]="activeKey" [presence]="presence" [online]="onlineIds"
        [loading]="loadingList" [canAssign]="capabilities.canAssign" [canSupervise]="capabilities.canAssign" [canSetAway]="capabilities.canSetAway" [myPresence]="myPresence"
        [meName]="meName" [mePhoto]="mePhoto" [settingsLink]="settingsLink" [pageLink]="widget ? ['/chat'] : null" [strings]="strings" (select)="getConversation($event)" (search)="onSearch($event)"
        [profileBase]="profileImageBase" [normalizeRow]="normalizeRow"
        (setPresence)="onSetPresence($event)" (newConversation)="openNewConversation()">
      </chat-conversation-list>
    </section>

    <!-- coluna 2: conversa -->
    <section class="card chat-card chat-card--thread">
      <chat-connection-banner [issue]="bannerIssue" [strings]="strings"></chat-connection-banner>

      <ng-container *ngIf="activeConversation as conv; else pickOne">
        <chat-thread-header [name]="conv.name" [photo]="conv.photo" [role]="conv.role" [presence]="activePresence" [showBack]="true"
          [canInvite]="canInviteHere" [propertyRoute]="propertyRoute"
          [propertyQueryParams]="propertyQueryParams" [propertyLink]="conv.propertyLink" [ownerName]="conv.supervised ? conv.ownerName : undefined"
          [assignedName]="activeAssignedName" [participantNames]="participantNames" [typing]="typingActive" [typingMode]="typingMode"
          [detailsOpen]="detailsOpen" [searchOpen]="threadSearchOpen" [strings]="strings"
          (back)="closeConversation()" (invite)="onInvite()"
          (toggleDetails)="toggleDetails()" (toggleSearch)="toggleThreadSearch()"></chat-thread-header>

        <!-- pesquisa na conversa -->
        <div *ngIf="threadSearchOpen" class="chat-search">
          <chat-icon name="search" [size]="15"></chat-icon>
          <input #threadSearchInput type="search" class="chat-search__input" autocomplete="off" [placeholder]="strings.searchInConversationPlaceholder"
            [attr.aria-label]="strings.searchInConversation" [value]="threadSearch" (input)="onThreadSearch($event)"
            (keydown.enter)="stepHit(1)" (keydown.escape)="toggleThreadSearch()">
          <span class="chat-search__count" role="status">{{ hitsLabel }}</span>
          <button type="button" class="chat-search__btn" [attr.aria-label]="strings.previousHit" [disabled]="threadHits.length === 0" (click)="stepHit(-1)">
            <chat-icon name="arrowdown" [size]="15" class="chat-search__up"></chat-icon>
          </button>
          <button type="button" class="chat-search__btn" [attr.aria-label]="strings.nextHit" [disabled]="threadHits.length === 0" (click)="stepHit(1)">
            <chat-icon name="arrowdown" [size]="15"></chat-icon>
          </button>
          <button type="button" class="chat-search__btn" [attr.aria-label]="strings.close" (click)="toggleThreadSearch()">
            <chat-icon name="close" [size]="15"></chat-icon>
          </button>
        </div>

        <chat-assign-banner *ngIf="showAssignBanner" [since]="unansweredSince" [noOwner]="!conv.assignedUserAppId"
          [canTakeOver]="canTakeOver" [canAssign]="capabilities.canAssign" [panelOpen]="assignOpen" [busy]="assignBusy"
          [strings]="strings" (takeOver)="onTakeOver()" (assign)="toggleAssignPanel()"></chat-assign-banner>

        <chat-thread [messages]="conv.messages" [meId]="meId" [otherId]="conv.userId" [otherPhoto]="conv.photo" [otherName]="conv.name"
          [participants]="conv.participants || []" [profileBase]="profileImageBase"
          [conversationKey]="activeKey" [loading]="loadingMessages" [typing]="typingActive" [highlight]="threadSearch"
          [focusKey]="threadFocusKey" [canManageVisits]="canManageVisitsHere" [canQualify]="canQualifyHere" [strings]="strings"
          [editWindowSeconds]="capabilities.messageEditWindowSeconds" [deleteWindowSeconds]="capabilities.messageDeleteWindowSeconds"
          (editMessage)="onEditMessage($event)" [canReply]="canReplyHere" (reply)="onReplyMessage($event)" (jumpTo)="onJumpTo($event)" (react)="onReact($event)"
          (retry)="onRetry($event)" (deleteMessage)="deleteMessage($event)" (deleteFile)="deleteFile($event)" (openImage)="openLightbox($event)"
          [actionBusy]="visitActionBusy"
          (visitAction)="onVisitAction($event)" (cardAction)="onCardAction($event)" [dealId]="conv.deal ? conv.deal.id : null"></chat-thread>

        <!-- fase 3: o próximo passo da conversa, uma linha e um botão -->
        <chat-next-step *ngIf="!conv.supervised && nextStep as step" [step]="step" [busy]="!!visitActionBusy" [strings]="strings"
          (act)="onNextStep($event)" (dismiss)="dismissNextStep($event)"></chat-next-step>

        <chat-composer *ngIf="!conv.supervised" [conversationKey]="activeKey" [editing]="editingMessage"
          (editSubmit)="onEditSubmit($event)" (editCancel)="onEditCancel()" [replyingTo]="replyingTo" [replyName]="replyName"
          (replyCancel)="onReplyCancel()" [canWriteNotes]="canWriteNotesHere"
          [canSchedule]="!!capabilities.canScheduleMessages && !!conv.chat" [scheduled]="scheduled" (schedule)="onSchedule($event)" (cancelScheduled)="onCancelScheduled($event)"
          [canSuggestProperties]="capabilities.canSuggestProperties" [quickReplies]="quickReplies" [templateVars]="templateVars" [mentionCandidates]="mentionCandidates" [actions]="composerActions"
          (action)="onComposerAction($event)" [strings]="strings"
          (send)="onSend($event)" (files)="onFiles($event)" (voice)="onVoice($event)" (recordingChange)="onRecording($event)"
          (suggestProperty)="onSuggestProperty()" (typing)="onTyping($event)"></chat-composer>
        <p *ngIf="conv.supervised" class="chat-page__readonly">
          <chat-icon name="info" [size]="16"></chat-icon>
          <span>{{ supervisedReadOnlyText }}</span>
          <button *ngIf="canTakeOver" type="button" class="btn btn-sm btn-soft-primary ms-auto flex-shrink-0" [disabled]="assignBusy" (click)="onTakeOver()">
            {{ strings.supervisedTakeOver }}
          </button>
        </p>
      </ng-container>

      <ng-template #pickOne>
        <chat-empty-state icon="chat" [title]="strings.pickConversationTitle" [text]="strings.pickConversationText"></chat-empty-state>
      </ng-template>
    </section>

    <!-- coluna 3: detalhes da conversa, ou o painel "Atribuir a" (só com canAssign) -->
    <section *ngIf="asideOpen && activeConversation" class="card chat-card chat-card--aside"
      [attr.aria-label]="assignOpen && capabilities.canAssign ? strings.assignTitle : strings.details">
      <chat-assign-panel *ngIf="assignOpen && capabilities.canAssign; else detailsPanel" [consultants]="consultants" [presence]="presence"
        [online]="onlineIds" [strings]="strings" (assign)="onAssign($event)" (close)="assignOpen = false"></chat-assign-panel>
      <ng-template #detailsPanel>
        <chat-details-panel [conversation]="activeConversation" [meId]="meId" [presence]="activePresence"
          [canInvite]="canInviteHere"
          [propertyRoute]="propertyRoute" [propertyQueryParams]="propertyQueryParams" [profileBase]="profileImageBase" [strings]="strings"
          [dealStages]="dealStages" [nextAction]="nextAction" [canTransfer]="canTransferHere" [stageBusy]="stageBusy"
          [canRemoveParticipants]="canRemoveParticipantsHere" [canLeave]="canLeaveHere" [canRemind]="activeIsClient" [showColleagues]="activeIsClient"
          [pendingInvites]="pendingInvites" (cancelInvite)="cancelInvite($event)"
          (invite)="onInvite()" (close)="setDetailsOpen(false)" (advanceStage)="advanceStage($event)" (addReminder)="openReminder()"
          (transfer)="openTransfer()" (removeParticipant)="removeParticipant($event)" (leave)="leaveConversation()"></chat-details-panel>
      </ng-template>
    </section>
  </ng-template>

</div>

<!--
  Modais ng-bootstrap. Rendem no <body>, fora do :host: por isso usam as
  classes do Bootstrap do CRM e não os tokens --chat-*.
-->

<!-- "Convidar consultor" -> invite_to_chat (contrato 6.3) -->
<ng-template #inviteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ strings.inviteTitle }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="strings.close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="text-muted mb-3">{{ strings.inviteText }}</p>
    <chat-colleague-picker [master]="colleagues.master || isMasterUser" [scope]="colleagueScope" [stores]="colleagues.stores" [storeId]="colleagueStoreId"
      [users]="colleagues.users" [loading]="colleaguesLoading" [selectedId]="inviteUserId" [exclude]="colleagueExclude" [profileBase]="profileImageBase"
      [strings]="strings" (scopeChange)="onColleagueScope($event)" (storeIdChange)="onColleagueStore($event)" (searchChange)="onColleagueSearch($event)"
      (selectedIdChange)="inviteUserId = $event"></chat-colleague-picker>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">{{ strings.cancel }}</button>
    <button type="button" class="btn btn-primary" [disabled]="!inviteUserId" (click)="confirmInvite()">{{ strings.inviteConfirm }}</button>
  </div>
</ng-template>

<!-- "Enviar imóvel" (maqueta EnviarImovel.dc.html) -> um send_property por imóvel -->
<ng-template #propertyModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ propertyPickMode === 'confirm' ? strings.confirmPropertyChoose : sendPropertyTitle }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="strings.close" (click)="cancelPropertyPick()"></button>
  </div>
  <div class="modal-body p-0">
    <!-- 2026-10-27: a minha agência / a rede, filtros e só imóveis disponíveis -->
    <chat-property-picker [mode]="propertyPickMode" [preset]="propertyFilters" [preselect]="propertyPreselectIds"
      [imageBase]="propertyImageBase" [canSeeNetwork]="canSeeNetworkProperties" [master]="isMasterUser" [initialScope]="propertyPickerScope" [strings]="strings"
      (selectedChange)="propertySelected = $event"></chat-property-picker>
  </div>
  <div class="modal-footer">
    <span class="flex-grow-1 text-muted small">{{ propertyPickMode === 'confirm' ? strings.confirmPropertyPickHint : propertySelectedText }}</span>
    <button type="button" class="btn btn-light" (click)="cancelPropertyPick()">{{ strings.cancel }}</button>
    <button type="button" class="btn btn-primary" [disabled]="propertySelected.length === 0" (click)="confirmSendProperties()">
      {{ propertyPickMode === 'confirm' ? strings.usePropertyLabel : sendPropertiesLabel }}
    </button>
  </div>
</ng-template>

<!-- Nova conversa privada com um colega -->
<ng-template #newConversationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ strings.newConversationTitle }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="strings.close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="text-muted mb-3">{{ strings.newConversationText }}</p>
    <chat-colleague-picker [master]="colleagues.master || isMasterUser" [scope]="colleagueScope" [stores]="colleagues.stores" [storeId]="colleagueStoreId"
      [users]="colleagues.users" [loading]="colleaguesLoading" [selectedId]="newConversationId" [exclude]="colleagueExclude" [profileBase]="profileImageBase"
      [strings]="strings" (scopeChange)="onColleagueScope($event)" (storeIdChange)="onColleagueStore($event)" (searchChange)="onColleagueSearch($event)"
      (selectedIdChange)="newConversationId = $event"></chat-colleague-picker>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">{{ strings.cancel }}</button>
    <button type="button" class="btn btn-primary" [disabled]="!newConversationId" (click)="startConversation()">{{ strings.newConversationStart }}</button>
  </div>
</ng-template>

<!-- O imóvel dentro dos modais de visita / horários: o da conversa, com "Trocar" -->
<ng-template #visitPropertyLine let-returnTo="returnTo">
  <div class="chat-modal__prop" [class.chat-modal__prop--none]="!visitProperty">
    <span class="chat-modal__prop-label">{{ strings.visitPropertyLabel }}</span>
    <ng-container *ngIf="visitProperty; else noVisitProp">
      <span class="chat-modal__photo chat-modal__photo--sm"><img *ngIf="visitProperty.image" [src]="visitProperty.image" alt=""></span>
      <span class="chat-modal__text">
        <span class="chat-modal__title">{{ visitProperty.title || visitProperty.reference }}</span>
        <span *ngIf="visitProperty.title && visitProperty.reference" class="chat-modal__meta">{{ visitProperty.reference }}</span>
      </span>
    </ng-container>
    <ng-template #noVisitProp><span class="chat-modal__text chat-modal__meta">{{ strings.noVisitProperty }}</span></ng-template>
    <button type="button" class="btn btn-link btn-sm p-0 flex-shrink-0" (click)="changeVisitProperty(returnTo)">
      {{ visitProperty ? strings.changeProperty : strings.confirmPropertyChoose }}
    </button>
  </div>
</ng-template>

<!-- Agendar visita (7.3): um modal só — imóvel, atalhos, data/hora, duração, agenda, email -->
<ng-template #visitModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ visitReschedule ? strings.rescheduleVisitTitle : strings.scheduleVisitTitle }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="strings.close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <ng-container *ngIf="!visitReschedule">
      <ng-container *ngTemplateOutlet="visitPropertyLine; context: { returnTo: 'visit' }"></ng-container>
    </ng-container>

    <!-- 2026-10-27: agendar já, ou perguntar a disponibilidade ao cliente -->
    <div *ngIf="!visitReschedule" class="chat-mode" role="radiogroup" [attr.aria-label]="strings.scheduleModeLabel">
      <button type="button" role="radio" class="chat-mode__btn" [class.chat-mode__btn--on]="visitMode === 'now'" [attr.aria-checked]="visitMode === 'now'"
        (click)="setVisitMode('now')"><chat-icon name="clock" [size]="15"></chat-icon>{{ strings.scheduleModeNow }}</button>
      <button type="button" role="radio" class="chat-mode__btn" [class.chat-mode__btn--on]="visitMode === 'ask'" [attr.aria-checked]="visitMode === 'ask'"
        (click)="setVisitMode('ask')"><chat-icon name="calendar" [size]="15"></chat-icon>{{ strings.scheduleModeAsk }}</button>
    </div>

    <ng-container *ngIf="visitMode === 'now'">
    <div class="chat-chips" role="group" [attr.aria-label]="strings.quickPicksLabel">
      <button *ngFor="let p of visitQuickPicks" type="button" class="chat-chip" [class.chat-chip--on]="isVisitPickOn(p)" (click)="applyVisitPick(p)">{{ p.label }}</button>
    </div>

    <div class="row g-3">
      <div class="col-7">
        <label class="form-label" for="chatVisitDate">{{ strings.dateLabel }}</label>
        <input id="chatVisitDate" type="date" class="form-control" [(ngModel)]="visitDate" (ngModelChange)="onVisitWhenChange()">
      </div>
      <div class="col-5">
        <label class="form-label" for="chatVisitTime">{{ strings.timeLabel }}</label>
        <input id="chatVisitTime" type="time" class="form-control" [(ngModel)]="visitTime" (ngModelChange)="onVisitWhenChange()">
      </div>
      <div class="col-12 col-sm-6">
        <label class="form-label" for="chatVisitDuration">{{ strings.durationLabel }}</label>
        <ng-select labelForId="chatVisitDuration" [items]="visitDurationOptions" bindLabel="label" bindValue="value" [clearable]="false"
          [searchable]="false" appendTo="body" [(ngModel)]="visitDuration" (ngModelChange)="onVisitWhenChange()"></ng-select>
      </div>
      <div *ngIf="visitConflictText" class="col-12">
        <div class="alert alert-warning py-2 mb-0 fs-13">{{ visitConflictText }}</div>
      </div>
      <div *ngIf="!visitReschedule" class="col-12">
        <div class="form-check form-switch">
          <input id="chatVisitEmail" class="form-check-input" type="checkbox" [(ngModel)]="visitSendEmail">
          <label class="form-check-label" for="chatVisitEmail">{{ strings.sendClientEmail }}</label>
        </div>
      </div>
    </div>
    </ng-container>

    <ng-container *ngIf="visitMode === 'ask'">
      <div class="alert alert-info d-flex gap-2 py-2 fs-13" role="note">
        <chat-icon name="info" [size]="16"></chat-icon><span>{{ strings.askAvailabilityNotice }}</span>
      </div>
      <div class="chat-chips" role="group" [attr.aria-label]="strings.quickPicksLabel">
        <button *ngFor="let p of visitQuickPicks" type="button" class="chat-chip" [class.chat-chip--on]="isSlotPickOn(p)"
          [disabled]="!isSlotPickOn(p) && visitSlots.length >= 5" (click)="toggleSlotPick(p)">{{ p.label }}</button>
      </div>
      <div *ngFor="let slot of visitSlots; let i = index" class="row g-2 align-items-center mb-2">
        <div class="col-6"><input type="date" class="form-control" [attr.aria-label]="strings.dateLabel" [(ngModel)]="slot.date"></div>
        <div class="col-4"><input type="time" class="form-control" [attr.aria-label]="strings.timeLabel" [(ngModel)]="slot.time"></div>
        <div class="col-2 text-end">
          <button type="button" class="btn btn-soft-danger btn-icon btn-sm" [disabled]="visitSlots.length === 1" [attr.aria-label]="strings.removeSlot"
            (click)="removeVisitSlot(i)"><chat-icon name="trash" [size]="15"></chat-icon></button>
        </div>
      </div>
      <button type="button" class="btn btn-soft-primary btn-sm" [disabled]="visitSlots.length >= 5" (click)="addVisitSlot()">
        <chat-icon name="plus" [size]="14"></chat-icon> {{ strings.addSlot }}
      </button>
      <div class="row g-3 mt-1">
        <div class="col-12 col-sm-5">
          <label class="form-label" for="chatVisitDuration2">{{ strings.durationLabel }}</label>
          <ng-select labelForId="chatVisitDuration2" [items]="visitDurationOptions" bindLabel="label" bindValue="value" [clearable]="false"
            [searchable]="false" appendTo="body" [(ngModel)]="visitDuration"></ng-select>
        </div>
        <div class="col-12">
          <label class="form-label" for="chatVisitNote">{{ strings.noteLabel }}</label>
          <textarea id="chatVisitNote" class="form-control" rows="2" maxlength="500" [(ngModel)]="visitNote"></textarea>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">{{ strings.cancel }}</button>
    <button *ngIf="visitMode === 'now'" type="button" class="btn btn-primary" [disabled]="visitBusy || !visitDate || !visitTime" (click)="submitVisitNow()">
      <span *ngIf="visitBusy" class="spinner-border spinner-border-sm me-1" role="status"></span>{{ visitReschedule ? strings.confirmReschedule : strings.confirmSchedule }}
    </button>
    <button *ngIf="visitMode === 'ask'" type="button" class="btn btn-primary" [disabled]="visitBusy || !hasValidSlots" (click)="submitVisitRequest()">{{ strings.sendRequest }}</button>
  </div>
</ng-template>

<!-- Pedir avaliação de visita (7.3): escolher a visita; a ficha virtual vai como cartão -->
<ng-template #visitFormModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ strings.requestFormTitle }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="strings.close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-0">
    <p class="text-muted small px-3 pt-3 mb-2">{{ strings.requestFormText }}</p>
    <div class="chat-modal__list">
      <p *ngIf="visitListLoading" class="text-muted px-3 py-2 mb-0" role="status">{{ strings.loading }}</p>
      <p *ngIf="!visitListLoading && visitList.length === 0" class="text-muted px-3 py-3 mb-0">{{ strings.noVisits }}</p>
      <div *ngFor="let v of visitList; trackBy: trackByVisit" class="chat-modal__row chat-modal__row--static">
        <span class="chat-modal__text">
          <span class="chat-modal__title">{{ visitWhen(v) }}</span>
          <span class="chat-modal__meta">
            {{ strings.visitStatus[v.status] || v.status }}<ng-container *ngIf="v.property?.reference"> · {{ v.property?.reference }}</ng-container>
            <ng-container *ngIf="v.form?.answeredAt"> · {{ strings.formAnsweredShort }}</ng-container>
            <ng-container *ngIf="v.form?.requested && !v.form?.answeredAt"> · {{ strings.formRequested }}</ng-container>
          </span>
        </span>
        <button type="button" class="btn btn-soft-primary btn-sm flex-shrink-0" [disabled]="v.status === 'CANCELED' || visitFormBusy === v.id"
          (click)="sendVisitForm(v)">
          <span *ngIf="visitFormBusy === v.id" class="spinner-border spinner-border-sm me-1" role="status"></span>{{ strings.requestFormSend }}
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">{{ strings.close }}</button>
  </div>
</ng-template>

<!-- Qualificar (7.3): escolher as perguntas; ou editar as respostas em nome do cliente -->
<ng-template #qualificationModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ qualEditing ? qualAnswersTitle : strings.qualify }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="strings.close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <!-- Enviar: as perguntas como chips (tocar tira), com o que o cliente vai ver -->
    <ng-container *ngIf="!qualEditing">
      <p class="text-muted small">{{ strings.qualPreviewHint }}</p>
      <div class="chat-chips mb-3" role="group">
        <button *ngFor="let f of qualFieldKeys" type="button" class="chat-chip" [class.chat-chip--on]="qualFields[f]" [attr.aria-pressed]="qualFields[f]"
          (click)="toggleQualField(f)">
          <chat-icon *ngIf="qualFields[f]" name="check" [size]="12"></chat-icon>{{ strings.qualificationField[f] }}
        </button>
      </div>
      <div class="chat-qual-preview" aria-hidden="true">
        <div class="chat-qual-preview__title">{{ strings.qualificationTitle }}</div>
        <div class="chat-qual-preview__text">{{ strings.qualificationText }}</div>
        <ol class="chat-qual-preview__list">
          <li *ngFor="let f of qualSelectedFields">{{ strings.qualificationField[f] }}<span class="chat-qual-preview__hint"> · {{ strings.qualPreviewByField[f] }}</span></li>
        </ol>
        <p *ngIf="qualSelectedFields.length === 0" class="chat-qual-preview__text mb-0">{{ strings.qualPreviewEmpty }}</p>
      </div>
    </ng-container>

    <!-- Responder pelo cliente / editar: chips primeiro, campos só para o que precisa de número -->
    <ng-container *ngIf="qualEditing">
      <p class="text-muted small">{{ strings.qualAnswersHint }}</p>
      <div class="chat-qual-form">
        <p class="text-muted small mb-0">{{ strings.qualificationMultiHint }}</p>
        <div *ngIf="qualOptions.businessTypes.length > 0" class="chat-qual-form__field">
          <span class="form-label">{{ strings.businessTypeLabel }}</span>
          <div class="chat-chips" role="group">
            <button *ngFor="let o of qualOptions.businessTypes" type="button" class="chat-chip" [class.chat-chip--on]="isQualBusinessOn(o.id)"
              [attr.aria-pressed]="isQualBusinessOn(o.id)" (click)="setQualBusinessType(o.id)">{{ o.name }}</button>
          </div>
        </div>
        <div class="chat-qual-form__field">
          <label class="form-label" for="qualPropertyType">{{ strings.propertyTypeLabel }}</label>
          <ng-select labelForId="qualPropertyType" [items]="qualOptions.propertyTypes" bindLabel="name" bindValue="id" appendTo="body"
            [multiple]="true" [closeOnSelect]="false" [placeholder]="strings.propertyTypePlaceholder" [clearable]="true"
            [(ngModel)]="qualAnswers.propertyTypeGroupIds"></ng-select>
        </div>
        <div class="chat-qual-form__field">
          <span class="form-label">{{ strings.bedroomsLabel }}</span>
          <div class="chat-chips" role="group">
            <button *ngFor="let n of qualBedroomChips" type="button" class="chat-chip" [class.chat-chip--on]="isQualBedroomOn(n)"
              [attr.aria-pressed]="isQualBedroomOn(n)" (click)="setQualBedrooms(n)">T{{ n }}{{ n === 5 ? '+' : '' }}</button>
          </div>
        </div>
        <div class="chat-qual-form__field">
          <span class="form-label">{{ strings.qualificationField['budget'] }}</span>
          <div class="chat-chips mb-2" role="group">
            <button *ngFor="let v of qualBudgetChips" type="button" class="chat-chip" [class.chat-chip--on]="isQualBudgetOn(v)"
              (click)="setQualBudgetMax(v)">{{ budgetChipLabel(v) }}</button>
          </div>
          <div class="row g-2">
            <div class="col-6">
              <input id="qualBudgetMin" type="number" min="0" class="form-control" [placeholder]="strings.budgetMinLabel" [attr.aria-label]="strings.budgetMinLabel"
                [(ngModel)]="qualAnswers.budgetMin">
            </div>
            <div class="col-6">
              <input id="qualBudgetMax" type="number" min="0" class="form-control" [placeholder]="strings.budgetMaxLabel" [attr.aria-label]="strings.budgetMaxLabel"
                [(ngModel)]="qualAnswers.budgetMax">
            </div>
          </div>
        </div>
        <div class="chat-qual-form__field">
          <label class="form-label" for="qualNotes">{{ strings.notesLabel }}</label>
          <textarea id="qualNotes" class="form-control" rows="2" maxlength="1000" [placeholder]="strings.notesPlaceholder" [(ngModel)]="qualAnswers.notes"></textarea>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">{{ strings.cancel }}</button>
    <button *ngIf="!qualEditing" type="button" class="btn btn-soft-primary" [disabled]="!hasQualFields" (click)="sendQualification(true)">{{ strings.qualAnswerMyself }}</button>
    <button *ngIf="!qualEditing" type="button" class="btn btn-primary" [disabled]="!hasQualFields" (click)="sendQualification()">{{ strings.qualificationSend }}</button>
    <button *ngIf="qualEditing" type="button" class="btn btn-primary" (click)="saveQualification()">{{ strings.qualificationSave }}</button>
  </div>
</ng-template>

<!-- Transferir conversa (7.3) -->
<ng-template #transferModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ strings.transferTitle }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="strings.close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="text-muted mb-3">{{ strings.transferText }}</p>
    <chat-colleague-picker [master]="colleagues.master || isMasterUser" [scope]="colleagueScope" [stores]="colleagues.stores" [storeId]="colleagueStoreId"
      [users]="colleagues.users" [loading]="colleaguesLoading" [selectedId]="transferUserId" [exclude]="colleagueExclude" [profileBase]="profileImageBase"
      [strings]="strings" (scopeChange)="onColleagueScope($event)" (storeIdChange)="onColleagueStore($event)" (searchChange)="onColleagueSearch($event)"
      (selectedIdChange)="transferUserId = $event"></chat-colleague-picker>
    <label class="form-label mt-3" for="transferNote">{{ strings.transferNote }}</label>
    <textarea id="transferNote" class="form-control" rows="3" maxlength="2000" [(ngModel)]="transferNote"></textarea>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">{{ strings.cancel }}</button>
    <button type="button" class="btn btn-primary" [disabled]="!transferUserId || !transferNote.trim()" (click)="confirmTransfer()">{{ strings.transferConfirm }}</button>
  </div>
</ng-template>

<!-- Lembrete (7.3): evento no calendário do próprio, ligado à conversa -->
<ng-template #reminderModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ strings.reminderTitle }}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="strings.close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="chat-chips" role="group" [attr.aria-label]="strings.quickPicksLabel">
      <button *ngFor="let p of reminderQuickPicks" type="button" class="chat-chip" [class.chat-chip--on]="isReminderPickOn(p)" (click)="applyReminderPick(p)">{{ p.label }}</button>
    </div>
    <div class="row g-3">
      <div class="col-7">
        <label class="form-label" for="reminderDate">{{ strings.dateLabel }}</label>
        <input id="reminderDate" type="date" class="form-control" [(ngModel)]="reminderDate">
      </div>
      <div class="col-5">
        <label class="form-label" for="reminderTime">{{ strings.timeLabel }}</label>
        <input id="reminderTime" type="time" class="form-control" [(ngModel)]="reminderTime">
      </div>
      <div class="col-12">
        <label class="form-label" for="reminderNote">{{ strings.reminderNote }}</label>
        <input id="reminderNote" type="text" class="form-control" maxlength="255" [(ngModel)]="reminderNote">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">{{ strings.cancel }}</button>
    <button type="button" class="btn btn-primary" [disabled]="!reminderDate || !reminderTime || !reminderNote.trim()" (click)="saveReminder()">{{ strings.reminderSave }}</button>
  </div>
</ng-template>

<!-- Proposta (7.3): o modal partilhado do CRM; ao fechar, o cartao vai para a conversa -->
<app-proposal-modal *ngIf="openNewProposal && proposalDeal" [deal]="proposalDeal" [leadId]="proposalLeadId"></app-proposal-modal>

<!-- Lightbox das imagens de uma mensagem (setas do teclado navegam) -->
<ng-template #lightboxModal let-modal>
  <div *ngIf="lightbox as lb" class="chat-lightbox">
    <button type="button" class="chat-lightbox__close" [attr.aria-label]="strings.close" (click)="modal.dismiss()">
      <chat-icon name="close" [size]="18"></chat-icon>
    </button>
    <button *ngIf="lb.files.length > 1" type="button" class="chat-lightbox__nav chat-lightbox__nav--prev" [attr.aria-label]="strings.previousImage"
      (click)="lightboxStep(-1)">
      <chat-icon name="back" [size]="22"></chat-icon>
    </button>
    <div class="chat-lightbox__stage">
      <img class="chat-lightbox__img" [appAuthImage]="lightboxSrc" alt="">
    </div>
    <button *ngIf="lb.files.length > 1" type="button" class="chat-lightbox__nav chat-lightbox__nav--next" [attr.aria-label]="strings.nextImage"
      (click)="lightboxStep(1)">
      <chat-icon name="next" [size]="22"></chat-icon>
    </button>
    <div class="chat-lightbox__bar">
      <span class="chat-lightbox__name">{{ lightboxName }}</span>
      <span *ngIf="lb.files.length > 1" class="chat-lightbox__count">{{ lightboxCounter }}</span>
    </div>
  </div>
</ng-template>
